import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBoxEmail, NSBoxSensitive, NSButtonBlue, NSLine, NSLineText, NSPanel, NSSection, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { AccountLayout } from "../AccountLayout";
import { AccountRoutes } from "../AccountRoutes";
import { AccountGithubLogin } from "../components/AccountGithubLogin";
import { AccountGoogleLogin } from "../components/AccountGoogleLogin";

interface LoginPageProps extends NSARouterMakerResult
{ }

function LoginPage(props: LoginPageProps) 
{
    const NSBoxEmail_Email = useRef<NSBoxEmail>(null);
    const NSBoxSensitive_Password = useRef<NSBoxSensitive>(null);

    useEffect(() =>
    {
        const handleKeyDown = (event: KeyboardEvent) =>
        {
            if (event.key === "Enter")
                onLogin(() => { });
        };

        window.addEventListener("keydown", handleKeyDown);
        return () =>
        {
            window.removeEventListener("keydown", handleKeyDown);
        };
        // eslint-disable-next-line
    }, []);

    function onLogin(onFinished: () => void)
    {
        try
        {
            let email: string = NSBoxEmail_Email.current?.getValue() ?? "";
            let password: string = NSBoxSensitive_Password.current?.getValue() ?? "";
            props.account.server.session.Login({ email, password }).then(() =>
            {
                props.url.redirect(AccountRoutes.Home, {});
                onFinished();
            }).catch(onFinished);

        } catch (error)
        {
            props.notifier.onError(error as Error);
            onFinished();
        }
    }

    return (
        <AccountLayout {...props}
            title={{
                title: 'Login',
                description: 'Log in to your Namirasoft Account to manage and access the associated products and services.'
            }}
        >
            <NSSection>
                <NSPanel>
                    <NSBoxEmail
                        required={true}
                        title="Email"
                        ref={NSBoxEmail_Email}
                        menu={{
                            builtin: {
                                email: false
                            },
                            items: []
                        }}
                    />
                    <NSBoxSensitive
                        required={true}
                        title="Password"
                        ref={NSBoxSensitive_Password}
                    />
                </NSPanel>
                <NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
                <NSButtonBlue
                    title="Login"
                    onClick={{
                        action: (onFinished) =>
                        {
                            onLogin(onFinished);
                        }
                    }}
                />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <NSLineText title="OR" />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <AccountGoogleLogin {...props} />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <AccountGithubLogin {...props} />

                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <NSLine />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>

                <Link to={props.url.getLink(AccountRoutes.PasswordForget, [])} className="nsa-font-16-bold nsa-color-blue ">Forgot your password?</Link>
                <NSSpace size={NSSpaceSizeType.MINI}></NSSpace>
                <p className={`nsa-font-16-bold my-0 nsa-color-blue-dark `}>
                    Don`t have an account?
                    <Link className="nsa-color-blue ms-1" to={props.url.getLink(AccountRoutes.Register, [])}>
                        Register
                    </Link>
                </p>
            </NSSection>
        </AccountLayout>
    );
}

export default LoginPage;